import { render, staticRenderFns } from "./departmentSetting.vue?vue&type=template&id=6cdceaa0&scoped=true&"
import script from "./departmentSetting.vue?vue&type=script&lang=js&"
export * from "./departmentSetting.vue?vue&type=script&lang=js&"
import style0 from "./departmentSetting.vue?vue&type=style&index=0&id=6cdceaa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdceaa0",
  null
  
)

export default component.exports